import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "nanoid";
const initialState = [];
const toastSlice = createSlice({
    name: "toast",
    initialState,
    reducers: {
        addToast(state, action) {
            state.push(action.payload);
        },
        removeToast(state, action) {
            return state.filter((toast) => toast.id !== action.payload);
        },
    },
});
const addTimedToast = (toast, timeout = 5000) => (dispatch) => {
    const id = nanoid();
    dispatch(addToast({ ...toast, id }));
    window.setTimeout(() => {
        dispatch(removeToast(id));
    }, timeout);
};
export const addSuccessToast = (title, description, timeout = 5000) => addTimedToast({ variant: "success", title, description }, timeout);
export const addErrorToast = (title, description, timeout = 8000) => addTimedToast({ variant: "error", title: title || "Fehler", description }, timeout);
export const { addToast, removeToast } = toastSlice.actions;
export const toastSelector = (state) => state.toasts;
export default toastSlice.reducer;
